import type { EventBus } from "./EventBus";
import type { Entities } from "./Interpreter";

/**
 * Resolve a place's background to a single asset (v5). `background` may be a
 * plain string (one image) or a phase-keyed map ({ "night": "...", ... }).
 * For a map: try the current `phase`, then a `"default"` key, then any value;
 * finally fall back to `image`.
 */
export function resolveBackground(
  background: string | Record<string, string> | undefined,
  image: string | undefined,
  phase: string | undefined,
): string | undefined {
  if (typeof background === "string") return background;
  if (background && typeof background === "object") {
    if (phase && background[phase]) return background[phase];
    if (background.default) return background.default;
    const first = Object.values(background)[0];
    if (first) return first;
  }
  return image;
}

export function transitionRoom(
  entities: Entities,
  bus: EventBus,
  toPlaceId: string,
  prevCharIds?: string[],
  phase?: string,
): void {
  const place = entities.places[toPlaceId];

  if (place) {
    const bgAsset = resolveBackground(place.background, place.image, phase);
    if (bgAsset) {
      bus.emit("bg.set", { asset: bgAsset, transition: "dissolve", duration: 0.5, place_ref: toPlaceId });
    }
    if (place.music) {
      bus.emit("audio.play", { channel: "bgm", asset: place.music, loop: true, fade_in: 1 });
    }
  }

  if (prevCharIds) {
    for (const charId of prevCharIds) {
      bus.emit("sprite.hide", { id: charId, exit: "fade_out" });
    }
  }

  const newChars: string[] = place?.characters ?? [];
  for (const charId of newChars) {
    const charEntity = entities.characters[charId];
    if (charEntity?.default_sprite) {
      bus.emit("sprite.show", { id: charId, asset: charEntity.default_sprite, enter: "fade_in" });
    }
  }
}
